export default __webpack_public_path__ + "static/telepathology-05858993fbcfcbd0165b89737347c482.svg";